import { c as _c } from "react/compiler-runtime";
import { Card, CardBody, Button, Link } from "@heroui/react";
import { ArrowRight } from "lucide-react";
import type React from "react";
interface Props {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
}
function FeatureCard(t0) {
  const $ = _c(14);
  const {
    title,
    description,
    icon,
    link
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <div className="mb-4 text-secondary">{icon}</div>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h3 className="text-xl font-semibold mb-2">{title}</h3>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = <p className="text-default-500 mb-14">{description}</p>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button as="span" color="secondary" variant="light" className="absolute bottom-0 mb-4" endContent={<ArrowRight className="ml-2" />}>Learn More</Button>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t5 = <CardBody className="flex flex-col items-center text-center">{t1}{t2}{t3}{t4}</CardBody>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== link || $[12] !== t5) {
    t6 = <Card as={Link} href={link} className="hover:shadow-lg transition duration-300">{t5}</Card>;
    $[11] = link;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
export default FeatureCard;